import { authn as authnProto } from '@xmtp/proto';
import Long from 'long';
export default class AuthData {
    constructor({ walletAddr, createdNs }) {
        this.walletAddr = walletAddr;
        this.createdNs = createdNs;
    }
    static create(walletAddr, timestamp) {
        timestamp = timestamp || new Date();
        return new AuthData({
            walletAddr: walletAddr,
            createdNs: Long.fromNumber(timestamp.getTime()).multiply(1000000),
        });
    }
    static fromBytes(bytes) {
        const res = authnProto.AuthData.decode(bytes);
        return new AuthData(res);
    }
    toBytes() {
        return authnProto.AuthData.encode(this).finish();
    }
}
//# sourceMappingURL=AuthData.js.map